import React from 'react';
import UIComponent from 'components/UiComponent';
import config from 'root/../config';
import studentPortalConfig from './moduleConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { withRouter} from 'components/Routing';
import AppContext from 'components/appContext';
import authService from 'services/authService';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';

const MenuItem = ({data}) => {
    return (
        <div className="row full-height menu-item no-gutters">
            <div className="col menu-item__icon">
                <span className={"ico-" + data.code}></span>
            </div>
            <div className="col menu-item__name">
                <h3>{data.name}</h3>
                {data.description != "" &&
                    <p>{data.description}</p>
                }
            </div>
        </div>
    );
}

class SideBarMenuItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activePanel: false,
        }
    }

    _togglePanel(){  
        this.setState({
            activePanel: !this.state.activePanel,
        })
    }


    _onItemClick(key){
        let itemCode = this.context.appMap[this.props.data.code][key];
        let currentScene = this.context.appMap[this.props.data.code][this.context.currentScene];

        this.context.set('drawerOpen',false);
        if(itemCode != currentScene){
            this.props.router.navigate("/" + itemCode.path);
        }
    }

    render() {
        return (
            <React.Fragment>
                <ListItem button divider disableGutters style={{padding : 0}} className="menu-item--sidebar">
                    <ListItemIcon style={{marginRight : 0}}>
                        <span className={"ico-" + this.props.data.code}></span>
                    </ListItemIcon>
                    <ListItemText className="menu-item__name" inset primary={this.props.data.name} />
                    <span className="chevron-container" onClick={this._togglePanel.bind(this)}>
                        {this.context.appMap != null && this.context.appMap.hasOwnProperty(this.props.data.code) ?
                            this.state.activePanel ?
                                <FontAwesomeIcon icon={faChevronDown} size={"1x"}/>
                                :
                                <FontAwesomeIcon icon={faChevronRight} size={"1x"}/>
                            :
                            null
                        }
                    </span>
                </ListItem>
                <Collapse in={this.state.activePanel} timeout="auto">
                    {this.context.appMap != null && this.context.appMap.hasOwnProperty(this.props.data.code) ?
                        Object.keys(this.context.appMap[this.props.data.code]).map((key) => {
                            if(this.context.appMap[this.props.data.code][key].showInMenu){
                                return (
                                    <ListItem
                                        key={key}
                                        disableGutters
                                        button
                                        divider
                                        className="menu-item--sidebar menu-item--sidebar--child"
                                        style={{ padding: 0 }}
                                        onClick={() => this._onItemClick(key)}
                                    >
                                        <ListItemText className="menu-item__name" inset primary={this.context.appMap[this.props.data.code][key].name} />
                                    </ListItem>
                                )
                            }
                        })
                        :
                        null
                    }
                </Collapse>
            </React.Fragment>
        );
    }
}

const SideBarMenuItemWithRouter = withRouter(SideBarMenuItem);
SideBarMenuItem.contextType = AppContext;
class Menu extends React.Component {    
    constructor(props) {
        super(props);
    }

    onItemClick = (e, data) => {        
        if (!e.target.closest('.chevron-container') && !e.target.closest('.menu-item--sidebar--child') || !this.props.isSideBar){
            if(this.context.appMap != null && this.context.appMap.hasOwnProperty(data.code) > 0 && this.context.appMap[data.code][data.code].entryPoint == this.context.appMap[data.code][this.context.currentScene]){
                this.context.set('drawerOpen',false);
            }else{
                switch(data.code) {
                    case 'EVALUATIONS_MODULE':
                        this.context.set('drawerOpen',false);
                        this.props.router.navigate('/evaluations');
                    break;
                    case 'PROCEDURE_EVALUATIONS_MODULE':
                        this.context.set('drawerOpen',false);
                        this.props.router.navigate('/procedureevaluations');
                    break;
                }
            }
        }

        if(this.props.isSideBar){
            setTimeout(()=>{
                data.recalculateHeight(data.rowIndex)
            },200);
        }
    }

    _getViewInternals(data) {
        window.addEventListener("orientationchange", function() {
            if(data.hasOwnProperty("recalculateRowHeights")){
                setTimeout(()=>{
                    data.recalculateRowHeights();
                }, 50);
            }
        }, false);
    }

    render() {
        return (
            <React.Fragment>
                <UIComponent 
                    component="data-view"
                    mode="LIST"
                    availableModes="LIST"
                    lazyLoad={false}
                    url={config.apiAppUrl + studentPortalConfig.APIs.getModules}
                    urlParams={{
                        auth_token: authService.getToken(),
                        user_role: this.context.userDetails.CURRENT_ROLE
                    }}
                    itemComponent={this.props.isSideBar ? SideBarMenuItemWithRouter : MenuItem}
                    listCardHeight={this.props.isSideBar ? 30 : 120}
                    listCardMargin={this.props.isSideBar ? "" : "8px 15px"}
                    onItemClick={this.onItemClick.bind(this)}
                    dynamicHeight
                    onScroll={(scrollValues) => {this.context.updateScrollValue(scrollValues.scrollTop)}}
                    refreshOnUrlParamsChange={authService.getToken() ? true : false}
                />
            </React.Fragment>
        );
    }
}

export default withRouter(Menu);
Menu.contextType = AppContext;